class TC_SocialSharing {
    constructor() {
        if(!$('.sharer-link').length) {
            return;
        }

        this.initPopups();
    }

    initPopups() {
        let self = this;

        $('.sharer-link').each(function(i, link) {
            $(link).on('click', function(e) {
                e.preventDefault();
                window.open($(link).attr('href'), 'app', 'width=500, height=400, toolbar=0, menubar=no, location=0, resizable=yes');
            });
        });
    }
}
